import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TrashCanOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TrashCanOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M22 2.5h-7v-1c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H2v2h1.5v14c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5v-14H22v-2Zm-3.5 16c0 1.65-1.35 3-3 3h-7c-1.65 0-3-1.35-3-3v-14h13v14Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default TrashCanOutlined;